// extracted by mini-css-extract-plugin
module.exports = {"cpEditBuildingContainer":"EditBuilding_cpEditBuildingContainer__bRny2"};